<template>
    <div class="breadcrumb">
        <h1>
            {{topText}}
            <el-tooltip class="item" effect="dark" :placement="placement" v-if="tipsText">
                <div slot="content"><div v-html="tipsText" class="content_slot"></div></div>
                <i :class="tipsIcon"></i>
            </el-tooltip>
        </h1>
        <div style="display: none">{{bottomText}}</div>
    </div>
</template>
<style scoped>
    h1{ font-size: 16px; margin: 16px 0}
    .content_slot,.content_slot>>>a{ color: #fff; text-decoration: none}
    .el-tooltip__popper>>>a{ color: #fff}
</style>
<script>
    export default {
        name: "Breadcrumb",
        props:{
            topText:{
                type:String,
                default:""
            },
            bottomText:{
                type:String,
                default:""
            },
            tipsText:{
                type:String,
                default:""
            },
            tipsIcon:{
                type:String,
                default:"el-icon-question"
            },
            placement:{
                type:String,
                default:"right"
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue